<template>
  <div class="actions">
    <nd-button class="action main" v-if="showMainButton" @click="mainAction">{{ mainButtonTitle }}</nd-button>
    <div class="action sub" :class="{'logout': result.status==='SUCCESS'}" @click="subAction">{{ subButtonTitle }}</div>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
import { hasNativeMethod, jsBridge } from '@/assets/jsBridge'
import CountDownTool from '@/assets/CountDownTool'
import { getKey } from '@/assets/utils'

export default {
  name: 'signout-result-actions',
  props: {
    result: {
      type: Object,
      default: () => {}
    }
  },
  mounted () {
    if (this.result.status === 'SUCCESS') {
      this.countDownTimer = setInterval(() => {
        this.countDown--
        if (this.countDown <= 0) {
          clearInterval(this.countDownTimer)
          this.logout()
        }
      }, 1000)
    }
  },
  destroyed () {
    clearInterval(this.countDownTimer)
  },
  data () {
    return {
      countDown: 5,
      countDownTimer: null,
      buttonStategies: {
        HAS_LOAN: {
          title: '去还款',
          action: () => {
            this.$router.push({
              path: '/repayment/history',
              query: { currentTab: 'repayOrder' }
            })
          }
        },
        WAIT_PAY_RIGHTS_ORDER: {
          title: '去支付',
          action: () => {
            this.$router.push({
              path: '/repayment/history',
              query: { currentTab: 'expenseOrder' }
            })
          }
        },
        HAS_BENEFIT: {
          title: '查看我的权益',
          action: () => {
            const origin = process.env.VUE_APP_PAYURL
            const token = this.userInfo.token
            const channel = getKey('channel') || ''
            window.location.href = `${origin}/vip/ssvip/pre?token=${token}&channel=${channel}&refurl=${window.location.origin}`
          }
        },
        HAS_GOING_STATUS: {
          title: '再次发起',
          action: () => {
            this.$router.replace({
              path: '/mine/signout/risk-notice'
            })
          }
        }
      }
    }
  },
  computed: {
    ...mapState('user', {
      userInfo: (state) => state.userInfo
    }),
    showMainButton () {
      return this.result.status === 'FAILURE'
    },
    mainButtonTitle () {
      const strategy = this.buttonStategies[this.result.code]
      if (strategy) {
        return strategy.title
      }
    },
    subButtonTitle () {
      return this.result.status === 'SUCCESS' ? `我知道了，退出登录 (${this.countDown}s)` : '返回首页'
    }
  },
  methods: {
    ...mapMutations('user', ['setUserInfo']),
    mainAction () {
      const strategy = this.buttonStategies[this.result.code]
      if (strategy) {
        strategy.action()
      }
    },
    subAction () {
      if (this.result.status === 'SUCCESS') {
        this.logout()
      } else {
        this.backHome(true)
      }
    },
    logout () {
      this.setUserInfo({
        token: '',
        mobile: '',
        wu: '',
        name: ''
      })
      localStorage.removeItem('IRR24')
      localStorage.removeItem(CountDownTool.Keys.HomeCountDownEndTime)
      localStorage.removeItem(CountDownTool.Keys.PassCardCountDownTimeStamp)
      if (hasNativeMethod('loginOut')) {
        jsBridge('loginOut')
      }
      if (hasNativeMethod('navigateTo')) {
        jsBridge('navigateTo', { path: 'login', exitCurrent: true })
      } else {
        this.$router.push('/user/login')
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../../../assets/less/mixin.less";

.actions {
  text-align: center;
  .action {
    margin: 30px auto;
    height: 80px;
    border-radius: 40px;
  }
  .main {
    width: 320px;
    background: linear-gradient(90deg, #FF3333 0%, #FF5F34 100%);
  }
  .sub {
    width: 320px;
    border: 2px solid #FF4633;
    font-size: 32px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FF4633;
    line-height: 80px;
    text-align: center;
  }
  .logout {
    width: 460px;
  }
}
</style>